import { render } from "./ReceiverTable.vue?vue&type=template&id=73a489da&scoped=true"
import script from "./ReceiverTable.vue?vue&type=script&lang=js"
export * from "./ReceiverTable.vue?vue&type=script&lang=js"

import "./ReceiverTable.vue?vue&type=style&index=0&id=73a489da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a489da"]])

export default __exports__